// SelectedSupplierContext.tsx
import React, { createContext, useState } from "react";

interface Cart {
    id: string;
    name: string;
    // Add other fields as needed
}

interface SelectedSupplierContextType {
    cartItems: Cart[] | null;
    setCartItems: (cart: Cart[]) => void;
}

const CartContext = createContext<SelectedSupplierContextType | undefined>(undefined);

const CartContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [cartItems, setCartItems] = useState<Cart[]>([]);

    return <CartContext.Provider value={{ cartItems, setCartItems }}>{children}</CartContext.Provider>;
};

export default CartContextProvider;
export { CartContext };
